<script>
  import { authStore } from '../../stores/General';
  import Form from '../../components/form/Form.svelte';
  import Icon, { Save } from 'svelte-hero-icons';
  import PlainInput from '../form/PlainInput.svelte';
  import InputWrapper from '../form/InputWrapper.svelte';
  import { updateAuthUser } from "../../utils/auth";

  let form;
  let rules;
  const { user } = authStore;

  let first_name = $user?.first_name || '';
  let last_name = $user?.last_name || '';
  let email = $user?.email || '';
  let phone_number = $user?.phone_number || '';
  let country = $user?.country || '';
  let user_id = $user?.user_id;
  let picture = $user?.picture;
  let auth_type = $user?.auth_type;

  function onSubmit(e) {
    if (e.detail.valid) {
      const data = {
        first_name,
        last_name,
        email,
        phone_number,
        country,
        picture,
        auth_type,
        user_id,
      };
      updateAuthUser({ ...e.detail.data, user_id });
    }
  }
</script>

<div class="flex">
  <div class="w-28 min-w-max mr-10">
    {#if $user?.picture}
      <img class="h-28 w-28 rounded-full" src={$user?.picture} alt="" />
    {/if}
  </div>
  <div class="w-full">
    <!-- <div class="my-4">
      <button
        type="button"
        class="w-80 h-12 mb-2 relative inline-flex items-center justify-center px-1 py-1 rounded-md border shadow-nv border-custom-orange bg-custom-orange text-sm font-medium text-white hover:bg-custom-orange focus:z-10 focus:outline-none focus:ring-1 focus:ring-blue-600 focus:border-blue-600"
      >
        <span>Change Image</span>
      </button>
    </div>
    <div>
      Allowed JPG, GIF or PNG. Max size of 800kB.
    </div> -->
    <div class="mt-4">
      <Form {rules} on:submit={onSubmit} bind:this={form}>
        <div class="grid grid-cols-2 gap-4">
          <InputWrapper label="First Name">
            <PlainInput name="first_name" value={first_name} />
          </InputWrapper>
          <InputWrapper label="Last Name">
            <PlainInput name="last_name" value={last_name} />
          </InputWrapper>
          <InputWrapper label="E-mail">
            <PlainInput name="email" value={email} readonly={true} />
          </InputWrapper>
          <InputWrapper label="Phone Number">
            <PlainInput
              initialValue={$user?.phone_number}
              name="phone_number"
              value={phone_number}
            />
          </InputWrapper>
          <InputWrapper label="Country">
            <PlainInput initialValue={$user?.country} name="country" value={country} />
          </InputWrapper>
        </div>
        <div class="my-4 mt-20 flex">
          <button
            type="submit"
            class="w-80 h-12 mb-2 relative inline-flex items-center justify-center px-1 py-1 rounded-md border shadow-nv border-custom-orange bg-custom-orange text-sm font-medium text-white hover:bg-custom-orange focus:z-10 focus:outline-none focus:ring-1 focus:ring-blue-600 focus:border-blue-600"
          >
            <Icon src={Save} class="mr-2.5 h-5 w-5 text-white" solid />
            <span class="text-white">Save</span>
          </button>
          <button
            type="button"
            class="w-40 h-12 ml-10 mb-2 relative inline-flex items-center justify-center px-1 py-1 rounded-md border shadow-nv border-custom-orange text-sm font-medium text-custom-orange focus:z-10 focus:outline-none focus:ring-1 focus:ring-blue-600 focus:border-blue-600"
          >
            <span>Cancel</span>
          </button>
        </div>
      </Form>
    </div>
  </div>
</div>
